import React, { Component, Suspense } from 'react';

import { withTranslation } from 'react-i18next'
import Login from './Login'
import ForgotPassword from './ForgotPassword'
import Splash from './Splash'
import './App.css'

class App extends Component {
  state = {
    showForgotPassword: false
  }

  toggleShowForgotPassword = () => {
    this.setState((state) => {return {showForgotPassword: !state.showForgotPassword}} )
  }

  render() {
    const {t, i18n} = this.props;

    return (
          <div className="login-page center-block form-signin">
              <div className="login-languages">
                <a className={i18n.language === 'fi' ? "current" : ""} href="/#" onClick={() => i18n.changeLanguage('fi')}>fi</a> |
                <a className={i18n.language === 'sv' ? "current" : ""} href="/#" onClick={() => i18n.changeLanguage('sv')}>sv</a> |
                <a className={i18n.language === 'en' ? "current" : ""} href="/#" onClick={() => i18n.changeLanguage('en')}>en</a>
              </div>
              <div className="slogan">
                {t('common.slogan')}
              </div>
                {this.state.showForgotPassword &&
                <div>
                  <ForgotPassword/>
                  <a href="/#" onClick={this.toggleShowForgotPassword}>{t('login.back')}</a>
                </div>
              }
              {!this.state.showForgotPassword &&
                <div>
                  <Login />
                  <a href="/#" onClick={this.toggleShowForgotPassword} >{t('login.forgotPassword')}</a>
                </div>
              }
          </div>
    )
  }
}

const TranslatedApp = withTranslation()(App)

export default () => {
  return       (
    <Suspense fallback={<Splash/>}>
      <TranslatedApp/>
    </Suspense>
  )
  };
